"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isActive = exports.isSinterklaasCampaignPeriod = exports.isSinterklaasPeriod = exports.isChristmasPeriod = exports.isCyberMonday = exports.isBlackFriday = exports.isBlackFridayPeriod = exports.eventDates = exports.EventName = void 0;
var EventName;
(function (EventName) {
    EventName["BLACK_FRIDAY_PERIOD"] = "Black Friday period";
    EventName["BLACK_FRIDAY"] = "Black Friday";
    EventName["CYBER_MONDAY"] = "Cyber Monday";
    EventName["CHRISTMAS_PERIOD"] = "Christmas period";
    EventName["SINTERKLAAS_PERIOD"] = "Sinterklaas period";
    EventName["SINTERKLAAS_CAMPAIGN_PERIOD"] = "Sinterklaas campaign period";
})(EventName || (exports.EventName = EventName = {}));
exports.eventDates = {
    [EventName.BLACK_FRIDAY_PERIOD]: {
        start: '2024-11-10T00:00:00',
        end: '2024-12-02T23:59:59',
    },
    [EventName.BLACK_FRIDAY]: {
        start: '2024-11-29T00:00:00',
        end: '2024-11-29T23:59:59',
    },
    [EventName.CYBER_MONDAY]: {
        start: '2024-12-02T00:00:00',
        end: '2024-12-02T23:59:59',
    },
    [EventName.CHRISTMAS_PERIOD]: {
        start: '2024-12-10T00:00:00',
        end: '2024-12-24T23:59:59',
    },
    [EventName.SINTERKLAAS_PERIOD]: {
        start: '2024-11-12T00:00:00',
        end: '2024-12-05T23:59:59',
    },
    [EventName.SINTERKLAAS_CAMPAIGN_PERIOD]: {
        start: '2024-11-21T00:00:00',
        end: '2024-12-01T23:59:59',
    },
};
const isBlackFridayPeriod = (now) => (0, exports.isActive)(EventName.BLACK_FRIDAY_PERIOD, now);
exports.isBlackFridayPeriod = isBlackFridayPeriod;
const isBlackFriday = (now) => (0, exports.isActive)(EventName.BLACK_FRIDAY, now);
exports.isBlackFriday = isBlackFriday;
const isCyberMonday = (now) => (0, exports.isActive)(EventName.CYBER_MONDAY, now);
exports.isCyberMonday = isCyberMonday;
const isChristmasPeriod = (now) => (0, exports.isActive)(EventName.CHRISTMAS_PERIOD, now);
exports.isChristmasPeriod = isChristmasPeriod;
const isSinterklaasPeriod = (now) => (0, exports.isActive)(EventName.SINTERKLAAS_PERIOD, now);
exports.isSinterklaasPeriod = isSinterklaasPeriod;
const isSinterklaasCampaignPeriod = (now) => (0, exports.isActive)(EventName.SINTERKLAAS_CAMPAIGN_PERIOD, now);
exports.isSinterklaasCampaignPeriod = isSinterklaasCampaignPeriod;
const isActive = (event, now) => {
    const { start, end } = exports.eventDates[event];
    const currentDate = (now || new Date()).toISOString();
    const startDate = new Date(start).toISOString();
    const endDate = new Date(end).toISOString();
    return currentDate >= startDate && currentDate <= endDate;
};
exports.isActive = isActive;
